import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { loginUser } from '../redux/apiCalls/accidentApiCall';
import { useNavigate } from "react-router-dom";
import logo from "../assetes/logo.png";
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser({email: email, password: password}, navigate));
  };
    return (
    <>
<div className="bg-[#5c5c5c] flex justify-center h-screen">
  <div className="flex flex-col items-center text-center pt-[100px]">
    <div className="w-[225px]">
      <img src={logo} alt="logo" />
    </div>
    <div className="pt-[20px]">
      <h1 className="text-[rgb(84,216,251)] font-[700] leading-[33px]">
        Geben Sie bitte Ihre Benutzername und Passwort
      </h1>
      <h1 className="text-[rgb(84,216,251)] font-[700] leading-[33px]">
        um sich anzumelden
      </h1>
    </div>
    <form onSubmit={handleSubmit}>
            <div className="pt-[30px]">
              <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} required placeholder='Benutzername' className="bg-[rgb(255,189,89)] w-[295px] h-[40px] font-[400] text-[14px] rounded-[8px]  outline-none pl-[10px] pr-[10px] placeholder:text-[rgb(135,100,47)] placeholder:font-[700]" />
    </div>
    <div className="pt-[50px]">
      <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} required placeholder='Passwort' className="bg-[rgb(255,189,89)] w-[295px] h-[40px] font-[400] text-[14px] rounded-[8px]  outline-none pl-[10px] pr-[10px] placeholder:text-[rgb(135,100,47)] placeholder:font-[700]" />
    </div>
    <div className="pt-[50px]">
      <button type="submit" className="bg-[rgb(255,222,89)] w-[125px] h-[40px] font-[400] text-[13px] rounded-[8px] cursor-pointer">
      anmelden
      </button>
    </div>
    </form>

  </div>
</div>

    </>

    )
}

export default Login
